import React from "react";

export default function WeatheForecastDay(props) {
  function maxTemperature() {
    let temperature = Math.round(props.data.temp.max);
    return `${temperature} º`;
  }

  function minTemperature() {
    let temperature = Math.round(props.data.temp.min);
    return `${temperature} º`;
  }

  function day() {
    let date = new Date(props.data.dt * 1000);
    let day = date.getDay();

    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
  }

  function icon() {
    return `http://openweathermap.org/img/wn/${props.data.weather[0].icon}@2x.png`;
  }

  return (
    <div className="col">
      <div className="days">{day()}</div>
      <div className="icon">
        <img src={icon()} alt="weathericon" />
      </div>
      <div className="weatherForecastTemperature">
        <span className="temp-max">{maxTemperature()}</span>{" "}
        <span className="temp-min">{minTemperature()}</span>
      </div>
    </div>
  );
}
